module.exports = __webpack_public_path__ + "static/media/logo.2892b68a.svg";